import React, { useEffect, useState, useRef } from 'react';
import { GlobeIcon } from 'lucide-react';
import { Language } from '../i18n/translations';
interface LanguageSelectorProps {
  language: Language;
  onLanguageChange: (lang: Language) => void;
  isDark: boolean;
}
const languages: {
  code: Language;
  label: string;
}[] = [{
  code: 'en',
  label: 'English'
}, {
  code: 'zh',
  label: '中文'
}, {
  code: 'ja',
  label: '日本語'
}];
export function LanguageSelector({
  language,
  onLanguageChange,
  isDark
}: LanguageSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative" ref={dropdownRef} data-id="element-56">
      <button onClick={() => setIsOpen(!isOpen)} className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all duration-200 ${isDark ? 'hover:bg-[#2d3340] text-[#7b92a8]' : 'hover:bg-[#f5f5f5] text-[#5b7c8d]'}`} aria-label="Select Language" data-id="element-57">
        <GlobeIcon className="w-5 h-5" data-id="element-58" />
        <span className="text-sm font-medium" data-id="element-59">
          {languages.find(l => l.code === language)?.label}
        </span>
      </button>

      {isOpen && <div className={`absolute right-0 mt-2 w-32 rounded-xl shadow-lg overflow-hidden z-50 ${isDark ? 'bg-[#2d3340] border border-[#3a3f4a]' : 'bg-white border border-[#e8ecf0]'}`} data-id="element-60">
          {languages.map(lang => <button key={lang.code} onClick={() => {
        onLanguageChange(lang.code);
        setIsOpen(false);
      }} className={`w-full text-left px-4 py-2 text-sm transition-colors ${language === lang.code ? isDark ? 'bg-[#3a3f4a] text-white' : 'bg-[#f0f4f8] text-[#2c3e50]' : isDark ? 'text-[#7b92a8] hover:bg-[#353b4a]' : 'text-[#5b7c8d] hover:bg-[#f5f5f5]'}`} data-id="element-61">
              {lang.label}
            </button>)}
        </div>}
    </div>;
}